import AtelierForm from "@features/creation/ateliers/components/AtelierForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/ateliers/create")({
  loader: requirePermission(PERMISSIONS.CREATION.ATELIERS.CREATE),
  staticData: {
    title: "Nouvel atelier",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.ATELIERS.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreateAtelierPage,
});

function CreateAtelierPage() {
  return (
    <div className="max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvel atelier</h1>
        <p className="text-sm text-base-content/60">
          Créer un nouvel atelier de production
        </p>
      </div>
      <AtelierForm />
    </div>
  );
}
